import { i18n } from 'src/i18n';
import { I18nUtils } from 'src/utils/i18n-utils';

export const formatMonthlyPriceLong = (monthlyPrice: number, numberOfMonthlyInstallments?: number) =>
  formatMonthlyPrice(monthlyPrice, false, numberOfMonthlyInstallments);

export const formatMonthlyPriceShort = (monthlyPrice: number, numberOfMonthlyInstallments?: number) =>
  formatMonthlyPrice(monthlyPrice, true, numberOfMonthlyInstallments);

const formatMonthlyPrice = (monthlyPrice: number, shortFormat: boolean, numberOfMonthlyInstallments?: number) => {
  const monthlyPriceText = I18nUtils.message(i18n.price.monthlyPrice, { monthlyPrice });

  if (!numberOfMonthlyInstallments) {
    return monthlyPriceText;
  }

  const numberOfMonths = I18nUtils.message(shortFormat ? i18n.price.numberOfMonthsShort : i18n.price.numberOfMonths, {
    numberOfMonthlyInstallments,
  });

  return `${monthlyPriceText} ${numberOfMonths}`;
};
